import axios from "../axios-auth";
import orginal_axios from "axios";

export const productionCostingService = {
    getProductionCostingList,
    searchProductionCostingDetailList,
    saveProductionCosting,
    getProductionCostingDetail,
    getProductionCostingExcelExport
};

function getProductionCostingList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }

    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy,
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.costingMonth) {
        params["costingMonth"] = searchParams.costingMonth;
    }
    if (searchParams.manufacturingCostId) {
        params["manufacturingCostId"] = searchParams.manufacturingCostId;
    }
    if (searchParams.description) {
        params["description"] = searchParams.description;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/production-costings", { params });
}

function searchProductionCostingDetailList(searchParams) {
    let params = {};

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.costingMonth) {
        params["costingMonth"] = searchParams.costingMonth;
    }
    if (searchParams.manufacturingCostId) {
        params["manufacturingCostId"] = searchParams.manufacturingCostId;
    }

    return axios.get("/auth/search-production-costing-details", { params });
}

function saveProductionCosting(ProductionCosting) {
    if (!ProductionCosting.id) {
        // new
        return axios.post("/auth/production-costing", ProductionCosting);
    } else {
        // edit
        return axios.put("/auth/production-costing", ProductionCosting);
    }
}

function getProductionCostingDetail(id) {
    return axios.get("/auth/production-costing/" + id);
}

function getProductionCostingExcelExport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.costingMonth) {
        params["costingMonth"] = searchParams.costingMonth;
    }
    if (searchParams.manufacturingCostId) {
        params["manufacturingCostId"] = searchParams.manufacturingCostId;
    }
    if (searchParams.description) {
        params["description"] = searchParams.description;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (typeof (searchParams.isAddDetails) == 'boolean') {
        params["isAddDetails"] = searchParams.isAddDetails;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/production-costing-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}